import { Panel } from './Panel';
import { Config } from './Config';
import { css } from '@emotion/css';
import Slider from '@material-ui/core/Slider'
import { Single, StateS } from '../../ProtoPanes/Single';
import { Container } from 'react-bootstrap';
import { getText } from '../../ProtoPanes/DefaultData';
export type sizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
export interface area {
    span: number
    offset: number
}
export interface S {
    mapa: string;
    color: string;
    xs: area
    sm: area
    md: area
    lg: area
    xl: area
    xxl: area
}
export type State = StateS & S;
export class Mapa extends Single<S> {
    constructor(p: any) {
        super(p);
        this.init(p, {
            mapa: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.222409726129!2d-69.34174658528173!3d10.08085407440297!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e8766544a016131%3A0xca0b29cad01c43ac!2sAilanthus%20Sistems%2C%20C.A!5e0!3m2!1ses!2sve!4v1644862496726!5m2!1ses!2sve%22%20width=%22600%22%20height=%22450%22%20style=%22border:0;%22%20allowfullscreen=%22%22%20loading=%22lazy%22%3E%3C/iframe%3E', color: '#ffffffaa',
            xs: { span: 100, offset: 40 },
            sm: { span: 100, offset: 40 },
            md: { span: 100, offset: 50 },
            lg: { span: 100, offset: 60 },
            xl: { span: 100, offset: 60 },
            xxl: { span: 100, offset: 60 }
        });
    }
    Config = () => <Config save={this.save} setConfig={this.setData} title={this.state.title} setTitle={this.setTitle} config={this.state} />
    Panel = () => <Panel config={this.state} setConfig={this.setData} />
    Top = () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [a, { span, offset }] = this.getArea()
        return <Container><Slider className={css`&> .MuiSlider-thumb{border-radius: 0;
            border-top-left-radius: 10px;transform: rotate(45deg);}`}
            onChange={(e: any, d: any) => this.setSpanW(d)} max={100} min={0}
            step={1} value={[span, offset]} style={{ width: '100%' }} /></Container>
    }
    setArea = ({ span, offset }: Partial<area>) => {
        const [a, b] = this.getArea();
        const c: area = {
            span: span !== undefined ? span : b.span,
            offset: offset !== undefined ? offset : b.offset
        }
        this.setState({ [a]: c } as any);
    }
    getArea = () => {
        const { size, xs, sm, md, lg, xl, xxl } = this.state;
        return ((size === '570px') ? ['xs', xs] :
            (size === '780px') ? ['sm', sm] :
                (size === '990px') ? ['md', md] :
                    (size === '1080px') ? ['lg', lg] :
                        (size === '1320px') ? ['xl', xl] : ['xxl', xxl]) as [sizes, area];
    }
    setSpanW = ([offset, span]: number[]) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [a, b] = this.getArea();
        if (span - offset < 30) {
            if (b.offset !== offset) {
                if (offset > 70) { span = 100; offset = 70; }
                else if (span < 100) span = offset + 30;
            } else if (b.span !== span) {
                if (span < 30) { span = 30; offset = 0 }
                else if (offset > 0) offset = span - 30;
            }
        }
        this.setArea({ offset, span });
    }
    getDataSave = () => {
        const { title, html, mapa, color, xs, sm, md, lg, xl, xxl } = this.state;
        const data = JSON.stringify({});
        const props = JSON.stringify({ mapa, color, xs, sm, md, lg, xl, xxl });
        return { title, html:getText(html), data, props, type: 'mapa' };
    }
}
